<div class="forgot_password">

  <div class="middle-box text-center loginscreen  animated fadeInDown">
    <div>
      <img src="../../../assets/imgs/logo.png" alt="logo"/>
      <div *ngIf="!send" class="login_box" >
        <h3>Forgot Password</h3>
        <p>Enter the email address associated with your account, and we'll email you a link to reset your password</p>
        <form class="m-t" role="form" (submit)="sendEmail()">
          <div class="row">
            <div class="col-xs-12 mh-64">
              <app-epa-input label="Email *" [control]="forgotPasswordForm.get('email')">
              </app-epa-input>
            </div>
          </div>
          <button type="submit" class="btn btn-primary block full-width m-b m-t-sm" [disabled]="!forgotPasswordForm.valid">Reset Password</button>
          <a routerLink="/login"><small>Return to Login.</small></a>
        </form>
      </div>
      <div *ngIf="send" class="login_box">
        <h4>Please check the message sent to your email to reset your password.</h4>
        <button type="submit" class="btn btn-primary block full-width m-b m-t-md" routerLink="/login">Return to Login</button>
      </div>
    </div>
  </div>
</div>
